module.exports = __webpack_public_path__ + "img/promo.cab1fe48.jpg";